import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";
import avatar from "./assets/Alex.png";

type Section = {
	type: string;
	title: string;
	name?: string;
	post?: string;
	content?: string;
	paragraph?: string;
	items?: string[];
};

export const CaseStudySection: React.FC = () => {
	const { t } = useTranslation();
	const sections: Section[] = t("caseStudySection.sections", { returnObjects: true });

	return (
		<section className={styles.CaseStudySection}>
			<div className={styles.CaseStudySection__background} />
			<div className={`${styles.CaseStudySection__content} app-container`}>
				<div className={styles.CaseStudySection__leftPart}>
					<h2 className={styles.CaseStudySection__title}>{t("caseStudySection.title")}</h2>

					{Array.isArray(sections) &&
						sections.map((section, index) => {
							switch (section.type) {
								case "paragraph":
									return (
										<React.Fragment key={index}>
											<h3 className={styles.CaseStudySection__subTitle}>
												{section.title}
											</h3>
											<p className={styles.CaseStudySection__paragraph}>
												{section.content}
											</p>
										</React.Fragment>
									);
								case "list":
									return (
										<React.Fragment key={index}>
											<h3 className={styles.CaseStudySection__subTitle}>
												{section.title}
											</h3>
											<ul className={styles.CaseStudySection__list}>
												{Array.isArray(section.items) &&
													section.items.map((item, itemIndex) => (
														<li key={itemIndex}>{item}</li>
													))}
											</ul>
										</React.Fragment>
									);
								case "paragraph_with_list":
									return (
										<React.Fragment key={index}>
											<h3 className={styles.CaseStudySection__subTitle}>
												{section.title}
											</h3>
											<p className={styles.CaseStudySection__paragraph}>
												{section.paragraph}
											</p>
											<ul className={styles.CaseStudySection__list}>
												{Array.isArray(section.items) &&
													section.items.map((item, itemIndex) => (
														<li key={itemIndex}>{item}</li>
													))}
											</ul>
										</React.Fragment>
									);
								case "quote":
									return (
										<React.Fragment key={index}>
											<h3 className={styles.CaseStudySection__subTitle}>
												{section.title}
											</h3>
											<p className={styles.CaseStudySection__paragraph}>
												<em>{section.content}</em>
											</p>
											<div className={styles.CaseStudySection__authorBlock}>
												<img
													src={avatar}
													alt={section.name}
													className={styles.CaseStudySection__avatar}
												/>
												<div className={styles.CaseStudySection__authorInfo}>
													<span className={styles.CaseStudySection__authorName}>
														{section.name}
													</span>
													<span className={styles.CaseStudySection__authorPost}>
														{section.post}
													</span>
												</div>
											</div>
										</React.Fragment>
									);
								default:
									return null;
							}
						})}
				</div>
			</div>
		</section>
	);
};
